export const RECEIVE_INSTITUTION_PERMISSION_LIST =
  'RECEIVE_INSTITUTION_PERMISSION_LIST';
export const REQUEST_INSTITUTION_PERMISSION_LIST =
  'REQUEST_INSTITUTION_PERMISSION_LIST';
export const INSTITUTION_PERMISSION_LIST_ERROR =
  'INSTITUTION_PERMISSION_LIST_ERROR';
export const RECEIVE_USER_PERMISSION_LIST = 'RECEIVE_USER_PERMISSION_LIST';
export const REQUEST_USER_PERMISSION_LIST = 'REQUEST_USER_PERMISSION_LIST';
export const USER_PERMISSION_LIST_ERROR = 'USER_PERMISSION_LIST_ERROR';
